"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _configProvider = require("../config-provider");
var _button = _interopRequireWildcard(require("./button"));
Object.keys(_button).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _button[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _button[key];
    }
  });
});
var _foxButtonGroup = _interopRequireDefault(require("./fox-button-group"));
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var Button = /*#__PURE__*/_react["default"].forwardRef(function (_a, ref) {
  var sourceTheme = _a.theme,
    sourceType = _a.type,
    sourceGhost = _a.ghost,
    className = _a.className,
    _a$compact = _a.compact,
    compact = _a$compact === void 0 ? false : _a$compact,
    size = _a.size,
    sourceDanger = _a.danger,
    rest = __rest(_a, ["theme", "type", "ghost", "className", "compact", "size", "danger"]);
  var _useContext = (0, _react.useContext)(_configProvider.ConfigContext),
    getPrefixCls = _useContext.getPrefixCls;
  var prefixCls = getPrefixCls('btn', rest.prefix);
  var type = 'default';
  // 这里决定修改 Button 样式的设定
  var theme = sourceTheme;
  var ghost = sourceGhost;
  var danger = sourceDanger;
  if (danger) {
    theme = undefined;
    type = undefined;
  } else if (sourceType === 'soft-highlight' || sourceType === 'soft') {
    if (theme === 'primary') {
      type = 'soft-primary';
      theme = undefined;
    } else {
      type = 'soft-secondary';
      theme = undefined;
    }
  } else if (sourceType === 'soft-primary' || sourceType === 'soft-secondary') {
    type = sourceType;
    theme = undefined;
  } else if (sourceType === 'ghost') {
    type = 'primary';
    ghost = true;
  } else if (theme === 'secondary') {
    type = sourceType;
    theme = undefined;
  } else if (sourceType === 'primary' && theme === 'primary') {
    type = 'primary';
    theme = undefined;
  } else if (theme === 'danger') {
    type = sourceType;
    theme = undefined;
    danger = true;
  } else {
    type = sourceType;
    theme = sourceTheme;
  }
  var injectThemeClass = theme ? "".concat(prefixCls, "-theme-").concat(theme) : undefined;
  // const type = sourceType === 'soft' || sourceType === 'soft-highlight' ? 'primary' : sourceType;
  return /*#__PURE__*/_react["default"].createElement(_button["default"], (0, _extends2["default"])({
    ref: ref,
    type: type,
    ghost: ghost,
    compact: compact,
    danger: danger,
    className: (0, _classnames["default"])(className, injectThemeClass),
    size: size
  }, rest));
});
Button.displayName = "FoxButton";
Button.Group = _foxButtonGroup["default"];
// eslint-disable-next-line no-underscore-dangle
Button.__ANT_BUTTON = _button["default"].__ANT_BUTTON;
Button.defaultProps = _button["default"].defaultProps;
// type primary ghost dashed link text default
// danger
// disabled
// ghost
// theme primary secondary success warning danger info light dark
// theme
// primary
// secondary
// success
// warning
// danger
// info
// light
// dark
// {
//     fg: string
//     bg: string
// }
// type
// link | text | outline | filled | ghost | dashed
// "link" | "text" | "default" | "primary" | "ghost" | "dashed"
var _default = exports["default"] = Button;